// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"309":"7671f26f17c9495f7b92","348":"affb0e8e6e66cd57895d","533":"b00036d029486146f2f7","626":"3dfb0b8afe8dd63e6850","700":"9adbfea4d4b38918c653","808":"782a935350b8260ddb87","938":"09dd76662245c61db64e"}[chunkId] + ".js";
};